import Vuex from 'vuex';
import Vue from 'vue';
import user from './user/index';
import clients from './clients/index';
import companies from './companies/index';
import bailiffs from './bailiffs/index';
import costTypes from './cost-types/index';
import courts from './courts/index';
import contracts from './contracts';
import discountTypes from './discountTypes';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        clients,
        companies,
        bailiffs,
        costTypes,
        courts,
        contracts,
        discountTypes
    }
});
